import React from "react";
import { buscarGRUsPorCPFPorPagina } from "../actions/GRUActions";
import { formatLongToDate } from "../../../helpers/Data";
import { View, TableColumn, LinkAction, Table, Dialog } from "react-template";
import GRUContainer from '../../../components/formbuilder/container/GRUContainer'

class ListAllFillableGRU extends View {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      url: "/grus",
      camposFiltrando: "",
      activeLoader: true
    };
  }

  formatData(resData) {
    let content = [];
    resData.content.forEach(item => {
      let id = item.id;
      let titulo = JSON.parse(item.formEditavel).titulo;
      let dataCriacao = item.dataCriacao;
      let status = item.status;
      content.push({ id, titulo, dataCriacao, status });
    });
    resData.content = content;
    return resData;
  }

  componentDidMount() {
    this.getAllGRU(this.state.url + "?size=10&status=true"+this.state.camposFiltrando);
  }

  onPaginator = url => {
    this.getAllGRU(url + this.state.camposFiltrando);
  };

  onFilter = camposFiltrando => {
    const url = this.state.url + "?size=&status=true" + camposFiltrando;
    this.setState({ camposFiltrando });
    this.getAllGRU(url, true);
  };

  getAllGRU = (url, filtrando = false) => {
    buscarGRUsPorCPFPorPagina(
      url,
      res => {
        if (filtrando && res.data.numberOfElements === 0) {
          this.setState({ camposFiltrando: "&status=true" });
          this.noResultOnFilter();
          return;
        }
        const resData = this.formatData(res.data);
        this.setState({ data: resData, activeLoader: false });
      },
      error => {
        this.setState({ activeLoader: false });
        this.notifyError("Erro ao carregar as GRUs", "");
      }
    );
  };

  fillModal(id) {
      return  <GRUContainer idForm={id} />;
  }

  fillGRU = (event, data) => {
      this.displayModal('Criando Submissao',
      '',
      this.fillModal(data.id));
  }

  dataMapper = data => {
    return (
      <tr key={data.id}>
        <TableColumn
          width="70"
          headers="titulo"
          content={data.titulo}
          label="Titulo"
          sorted
          filter={{ atributo: "titulo", coluna: "Titulo", tipo: "String" }}
        />
        <TableColumn
          width="10"
          headers="dataCriacao"
          content={formatLongToDate(data.dataCriacao)}
          label="Criação"
          limit="10"
          sorted
          filter={{
            atributo: "dataCriacao",
            coluna: "Data de criação",
            tipo: "Date"
          }}
        />
        <TableColumn
          width="10"
          headers="status"
          content={data.status}
          label="Status"
          status
        />
        <TableColumn width="10" headers="acoes" action>
          <LinkAction
            icone="remove_red_eye"
            type="table"
            onClick={(e) => this.fillGRU(e, data)}
            tooltip="Detalhar"
          />
        </TableColumn>
      </tr>
    );
  };

  handleSubmitFiltro = e => {
    e.preventDefault();
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });


  render() {
    return (
      <section>
        <Table
          title="Listar GRUs Preenchiveis"
          summary="Listagem dos GRUs preenchiveis no sistema."
          url={this.state.url}
          data={this.state.data}
          onFilter={this.onFilter}
          dataMapper={this.dataMapper}
          onPaginator={this.onPaginator}
          displayLoading={this.state.activeLoader}
          noPadding
          card
        />
      </section>
    );
  }
}

export default ListAllFillableGRU;



// WEBPACK FOOTER //
// ./src/view/gru/list/ListAllFillableGRU.js